import Button from '@mui/material/Button';
import { SxProps } from '@mui/material/styles';
import React from 'react';
import theme from '../color/theme';

interface BTButtonProps {
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    sx?: SxProps; // MUI 스타일 확장 가능
    color?: string; // 배경색
    textColor?: string; // 텍스트 색상
    borderColor?: string;
    width?: string; // 버튼 가로 크기
    height?: string; // 버튼 세로 크기
    hoverColor?: string;         // ✅ 롤오버 배경색
    hoverBorderColor?: string;   // ✅ 롤오버 보더색
    hoverTextColor?: string;

    // Google Analytics 추적을 위한 속성
    'data-analytics-name'?: string;
}

const BTButton: React.FC<BTButtonProps> = ({ 
    children, 
    onClick, 
    disabled = false, 
    sx = {}, 
    color = theme.colors.buttonCancel20, 
    textColor = theme.colors.textCancel,
    borderColor = 'transparent',
    width = '120px', // 기본 가로 크기
    height = '48px', // 기본 세로 크기
    hoverColor,
    hoverBorderColor,
    hoverTextColor,
    'data-analytics-name': dataAnalyticsName,
}) => {
    return (
        <Button
            variant="contained"
            sx={{
                backgroundColor: color, // 동적으로 배경색 설정
                color: textColor, // 동적으로 텍스트 색 설정
                fontSize: '18px',
                fontWeight: '600',
                boxShadow: 'none',

                border: `1px solid ${borderColor}`,
                borderRadius: '8px',

                '&:hover': { 
                    backgroundColor: hoverColor || color,
                    borderColor: hoverBorderColor || borderColor, // ✅ 롤오버 시 보더색 변경
                    color: hoverTextColor || textColor,
                    boxShadow: 'none',
                },
                minWidth: width, // 동적으로 가로 크기 설정
                height: height, // 동적으로 세로 크기 설정
                '&:focus, &:active': { outline: 'none' },
                ...sx, // 추가 스타일 적용 가능
            }}
            onClick={onClick}
            disabled={disabled}
            data-analytics-name={dataAnalyticsName}
        >
            {children}
        </Button>
    );
};

export default BTButton;
